<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { BoxBufferGeometry, MeshBasicMaterial, Mesh, Color } from 'three'

export default {
  props: {
    colorHover: {
      default: '#00fa00'
    },
    colorDefault: {
      default: '#fafa00'
    }
  },
  mixins: [O3DG2],
  methods: {
    setupCube () {
      let geo = new BoxBufferGeometry(2, 2, 2, 3, 3, 3)
      let colors = {
        default: new Color(this.colorDefault),
        hovering: new Color(this.colorHover)
      }
      let mat = new MeshBasicMaterial({ wireframe: true, color: colors.default })
      let mesh = new Mesh(geo, mat)
      this.onLoop(() => {
        mesh.rotation.x += 0.01
      })

      this.ctx.rayplay.add(mesh, () => {
        this.$emit('clicker')
      })

      this.ctx.rayplay.hover(mesh, () => {
        mat.color = colors.hovering
        console.log('enter')
      }, () => {
        mat.color = colors.default
        console.log('leave')
      })
      this.onClean(() => {
        this.ctx.rayplay.remove(mesh)
      })

      this.$watch('visible', () => {
        mesh.visible = this.visible
      })

      this.o3d.add(mesh)
    }
  },
  data () {
    return {
      showCube: false
    }
  },
  mounted () {
    this.setupCube()
  }
}
</script>

<style>
</style>
